module.exports = __webpack_public_path__ + "7b9aca653ec1cf351a720246c5a6afb1.svg";